import { styled } from '@linaria/react';

import Demo, {
  DemoToggleButtonGroupControl,
} from '@/components/Demo';
import Paper from '@/components/Paper';
import CodeSnippetProvider from '@/components/CodeSnippet/CodeSnippetProvider';

import { CODE_BACKGROUND } from './index.constants';
import { INITIAL_VALUE, constructSnippet } from './FlexMulti.helpers';
import Element from './Element';

function FlexMulti({ codeOutput }) {
  return (
    <Demo
      initialValues={{
        flexDirection: INITIAL_VALUE,
      }}
      controlPosition="top"
      customGrid={{ gridTemplateColumns: '1fr' }}
      outputWrapper={null}
      controls={[
        <ResponsiveToggleButtonGroupControl
          key="flexDirection"
          id="flexDirection"
          label="Flex Direction"
          options={['row', 'column', 'row-reverse', 'column-reverse']}
        />,
      ]}
    >
      {({ flexDirection }) => {
        return (
          <>
            <Row>
              <CodeColumn>
                <CodeSnippetProvider
                  lang="css"
                  code={constructSnippet(flexDirection)}
                >
                  {codeOutput}
                </CodeSnippetProvider>
              </CodeColumn>
              <DemoColumn>
                <Container
                  style={{
                    width: '100%',
                    minHeight: 212,
                    flexDirection,
                  }}
                >
                  <BoxElement layout="position">1</BoxElement>
                  <BoxElement style={{ zIndex: 2 }}>2</BoxElement>
                  <BoxElement layout="position">3</BoxElement>
                </Container>
              </DemoColumn>
            </Row>
          </>
        );
      }}
    </Demo>
  );
}

const ResponsiveToggleButtonGroupControl = styled(
  DemoToggleButtonGroupControl
)`
  /* Hide the last 2 options with CSS, since they don't fit */
  @media (max-width: 34rem) {
    button:nth-child(3),
    button:nth-child(4) {
      display: none;
      user-select: none;
    }
  }
`;

const Row = styled.div`
  display: flex;
  gap: 16px;
  padding-bottom: 16px;

  @media (max-width: 42.25rem) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;
const Column = styled.div`
  position: relative;
  background: ${CODE_BACKGROUND};
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
`;

const CodeColumn = styled(Column)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const DemoColumn = styled(Column)`
  display: flex;
  justify-content: center;
  width: 240px;

  @media (max-width: 42.25rem) {
    width: 100%;
  }
`;

const Container = styled(Paper)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 16px 0px;
`;

const BoxElement = styled(Element)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 3rem;
  min-height: 3rem;
  padding: 0;
  background: white;
  font-size: 1.25rem;
  font-weight: var(--font-weight-medium);
`;

export default FlexMulti;
